﻿import angular from "angular";

import "./cart";
import "./cart-overview";
import "./customer-info";
import "./discounts";
import "./organization";
import "./checkout-newsletter";
import "./key-account";
import "../../services/cart";
import "../../services/user";
import "../../services/payment";
import "../../services/mailchimp";
import { showDarAddressModal } from '../../helpers/darAddressModal';

angular.module("folkeuni").component("checkoutDawa", {
  controller: function (
    Cart,
    User,
    PaymentService,
    Mailchimp,
    $rootScope,
    $scope,
    $location,
    $window,
    $document,
    debounce,
    $timeout
  ) {
    var $ctrl = this;
    $ctrl.personDataCustomerLink =
      "/om-folkeuniversitetet/folkeuniversitetets-persondatapolitik-for-deltagere/";
    $ctrl.salesAndDeliveryLink =
      "/til-deltagere/salgs-og-leveringsbetingelser/";
    $ctrl.checkout = {};
    $ctrl.cart = {};
    $ctrl.students = [];
    $ctrl.productIds = [];
    $ctrl.hasNewsletterToday = false;
    $ctrl.usingClerk = false;
    $ctrl.state = {
      loading: true,
      step: null,
    };
    $ctrl.checkoutInProgress = false;
    $ctrl.consentGiven = false;
    $ctrl.consentError = false;
    $ctrl.checkoutInvalidReason = "";
    $ctrl.showCheckoutInvalidReason = false;
    $ctrl.showLoadingOverlay = false;

    $ctrl.shopContinue = function () {
      var referrer = document.referrer;
      // Tjek om referrer matcher /område/program (fx /aarhus/program)
      var areaMatch = referrer && referrer.match(/https?:\/\/[^\/]+\/([^\/]+)\/program(\/|$)/);
      if (areaMatch && areaMatch[1] && areaMatch[1] !== "program") {
        // Naviger til område-program siden
        $window.location = '/' + areaMatch[1] + '/program';
      } else {
        // Ellers gå til hoved program siden
        $window.location = '/program';
      }
    };

    $ctrl._validityCheckers = [];
    $ctrl.registerValidityChecker = function (checker) {
      $ctrl._validityCheckers.push(checker);
    };
    $ctrl.isCheckoutValid = function () {
      if ($ctrl.checkoutInProgress) return false;
      if (!$ctrl.cart.products || $ctrl.cart.products.length === 0) return false;
      for (var i = 0; i < $ctrl._validityCheckers.length; i++) {
        if (!$ctrl._validityCheckers[i]()) return false;
      }
      if (!$ctrl.consentGiven) return false;
      return true;
    };

    $ctrl.getCheckoutInvalidReason = function () {
      if (!$ctrl.cart.products || $ctrl.cart.products.length === 0) return "Din kurv er tom.";
      if (!$ctrl.consentGiven) return "Du skal give samtykke for at fortsætte.";
      for (var i = 0; i < $ctrl._validityCheckers.length; i++) {
        if (!$ctrl._validityCheckers[i]())
          return "Udfyld alle påkrævede felter korrekt for at fortsætte.";
      }
      return "";
    };

    $ctrl.handleDisabledCheckoutClick = function () {
      $ctrl.checkoutInvalidReason = $ctrl.getCheckoutInvalidReason();
      $ctrl.showCheckoutInvalidReason = true;
      $scope.$broadcast("checkout:showAllErrors");
      if ($ctrl._hideReasonTimeout) $timeout.cancel($ctrl._hideReasonTimeout);
      $ctrl._hideReasonTimeout = $timeout(function () {
        $ctrl.showCheckoutInvalidReason = false;
      }, 3000);
    };

    $ctrl.$onInit = async function () {
      const cart = await Cart.read();

      // Hvis checkout mangler eller kun har tomme customer felter, prøv at hente fra localStorage
      if (isCheckoutEmptyOrDefault(cart.checkout)) {
        try {
          const customerInfo = await Cart.customerInfoLocalStorageGet(cart);
          if (customerInfo) {
            cart.checkout = JSON.parse(customerInfo);
          }
        } catch (e) { }
      }
      $ctrl.cart = cart;
      $ctrl.productIds = cart.products.map((item) => item.id);

      if ($ctrl.siteId == 3) {
        $ctrl.personDataCustomerLink =
          "/om-folkeuniversitetet/folkeuniversitetets-persondatapolitik-for-deltagere/";
        $ctrl.salesAndDeliveryLink = "/tilmelding";
      } else if ($ctrl.siteId == 15) {
        $ctrl.personDataCustomerLink =
          "/om-folkeuniversitetet/folkeuniversitetets-persondatapolitik-for-deltagere/";
        $ctrl.salesAndDeliveryLink =
          "/tilmelding-betaling/salgs-og-leveringsbetingelser";
      }
    };

    $rootScope.$on("cart.update", async function (evt, cart) {
      if ($ctrl.cart && $ctrl.cart.checkout) {
        cart.checkout = cart.checkout || $ctrl.cart.checkout;
      }

      if ($ctrl.cart && $ctrl.cart.newsletter) {
        cart.newsletter = cart.newsletter || $ctrl.cart.newsletter;
      }

      if (isCheckoutEmptyOrDefault(cart.checkout)) {
        await Cart.customerInfoLocalStorageGet(cart)
          .then((customerInfo) => {
            if (customerInfo) cart.checkout = JSON.parse(customerInfo);
          })
          .catch((error) => { });
      }

      $ctrl.cart = angular.copy(cart);
      $scope.$evalAsync();
      $ctrl.state.loading = false;
    });

    function isCheckoutEmptyOrDefault(checkout) {
      if (!checkout) return true;
      // Tjek om customer kun har country og createUser (default værdier)
      const customer = checkout.customer || {};
      const onlyCountryAndCreateUser =
        Object.keys(customer).length <= 2 &&
        customer.country &&
        typeof customer.createUser !== "undefined";
      return onlyCountryAndCreateUser;
    }

    $ctrl.checkout = async function () {
      if (!$ctrl.consentGiven) {
        $ctrl.consentError = true;
        return;
      }
      $ctrl.consentError = false;
      $ctrl.checkoutInProgress = true;
      try {
        User.validate(buildNewUser()).then(
          async function (successResponse) {
            if (successResponse.isValidAddress) {
              await internalCheckout();
            } else {
              showAddressModal(successResponse.suggestedAddress);
            }
          },
          function (errorResponse) { }
        );
      } finally {
        $ctrl.checkoutInProgress = false;
      }
    };

    $ctrl.hasStudentDiscount = function () {
      if (!$ctrl.cart || !$ctrl.cart.products) return false;
      return $ctrl.cart.products.some(function (product) {
        return (
          Array.isArray(product.discount) &&
          product.discount.some(function (discount) {
            return discount && discount.type === "Student";
          })
        );
      });
    };

    async function internalCheckout() {
      try {
        $ctrl.showLoadingOverlay = true;
        var acceptNewsletter = false;
        var subscriberObj = {
          email_address: $ctrl.cart.checkout.customer.email,
          interests: {},
        };

        ($ctrl.cart?.newsletter || []).forEach((category) => {
          (category.options || []).forEach((option) => {
            subscriberObj.interests[option.id] = !!option.selected;
            if (option.selected) acceptNewsletter = true;
          });
        });

        try {
          if ($ctrl.cart.checkout.customer.createUser) {
            var newUser = buildNewUser();
            await User.create(newUser);
          }
        } catch (error) { } // Ignorer fejl ved oprettelse af bruger

        if (acceptNewsletter) {
          try {
            await Mailchimp.subscribe($ctrl.siteId, subscriberObj);
          } catch (error) { } // Ignorer fejl ved ændring af nyhedsbrev
        }

        await paymentWindow();
      } catch (error) {
        console.error("Error during checkout:", error);
      } finally {
        $ctrl.showLoadingOverlay = false;
      }
    }

    function buildNewUser() {
      var userObj = {
        siteId: parseInt($ctrl.siteId),
        email: $ctrl.cart.checkout.customer.email,
        password: $ctrl.cart.checkout.customer.password || null,
        firstName: $ctrl.cart.checkout.customer.firstName,
        middleName: $ctrl.cart.checkout.customer.middleName || null,
        lastName: $ctrl.cart.checkout.customer.lastName,
        phoneNumber: $ctrl.cart.checkout.customer.phoneNumber.toString(),
        streetName: $ctrl.cart.checkout.customer.streetName,
        streetNumber: $ctrl.cart.checkout.customer.streetNumber,
        floorNumber: $ctrl.cart.checkout.customer.floorNumber || null,
        side: $ctrl.cart.checkout.customer.side || null,
        roomNumber: $ctrl.cart.checkout.customer.roomNumber || null,
        postalCode: $ctrl.cart.checkout.customer.postalCode,
        city: $ctrl.cart.checkout.customer.city,
        country: $ctrl.cart.checkout.customer.country,
      };
      return userObj;
    }

    async function checkout() {
      // Byg et nyt checkout-objekt, så vi ikke muterer originalen
      var sentCheckout = JSON.parse(JSON.stringify($ctrl.cart.checkout));

      sentCheckout.keyAccount = [];
      for (var i in $ctrl.cart.keyAccountFields) {
        var currentField = $ctrl.cart.keyAccountFields[i];

        sentCheckout.keyAccount.push({
          id: currentField.id,
          value: currentField.value ?? '',
        });
      }

      // Map student-id'er til students, så hver discount får en reference til den korrekte student
      var studentDiscounts = [];
      if (Array.isArray(sentCheckout.students)) {
        $ctrl.cart.products.forEach((product) => {
          if (Array.isArray(product.discount)) {
            product.discount.forEach((discount) => {
              if (discount.type === "Student") {
                var idx =
                  discount.studentIndex != null ? discount.studentIndex : null;
                if (idx == null || idx === -1) idx = 0;
                var student = sentCheckout.students[idx] || {};
                studentDiscounts.push({
                  id: discount.id,
                  place: student.place,
                  number: student.number,
                });
              }
            });
          }
        });
        sentCheckout.students = studentDiscounts;
      }

      // Map organization tickets til checkout.tickets (med id)
      var organizationTickets = [];
      if (Array.isArray($ctrl.cart.products)) {
        $ctrl.cart.products.forEach((product) => {
          if (product.organization && Array.isArray(product.tickets)) {
            product.tickets.forEach((ticket) => {
              organizationTickets.push({
                id: ticket.id,
                organization: ticket.organization,
                jobTitle: ticket.jobTitle,
              });
            });
          }
        });

        if (organizationTickets.length) {
          sentCheckout.tickets = organizationTickets;
        }
      }

      if (sentCheckout.customer && sentCheckout.customer.phoneNumber) {
        sentCheckout.customer.phoneNumber =
          sentCheckout.customer.phoneNumber.toString();
      }

      // Fjern company hvis det kun indeholder default værdier eller ikke er vinget af
      if ((sentCheckout.company && Object.keys(sentCheckout.company).length === 1) || !$ctrl.cart.checkout.business) {
        sentCheckout.company = null;
      }

      sentCheckout.siteId = $ctrl.siteId;

      try {
        const checkoutResult = await Cart.checkout(sentCheckout);
        return checkoutResult;
      } catch (err) {
        throw err;
      }
    }

    async function paymentWindow() {
      try {
        const checkoutResult = await checkout();
        if (checkoutResult.skipPayment) {
          window.location = checkoutResult.url;
        } else {
          PaymentService.openPaymentWindow(checkoutResult);
        }
      } catch (errorStuff) {
        if (errorStuff.status == 400) {
          $ctrl.termsError = errorStuff.data;
          $ctrl.ErrorTimer = $timeout(function () {
            $ctrl.termsError = null;
          }, 5000);
        } else {
          $ctrl.termsError =
            "Der skete en fejl og du stilles videre til din kurv.";
          $ctrl.ErrorTimer = $timeout(function () {
            $location.path("cart");
            $ctrl.termsError = null;
          }, 2500);
        }
      }
    }

    function showAddressModal(suggestedAddress) {
      showDarAddressModal(suggestedAddress, [
        {
          label: "Behold min adresse",
          classes: "contained danger",
          click: async (modal) => {
            modal.closeModal();
            await internalCheckout();
          },
        },
        {
          label: "Ret adressen",
          classes: "contained secondary",
          click: (modal) => {
            modal.closeModal();
            scrollToAddressField();
          },
        },
        {
          label: "Brug DAR-adresse",
          classes: "contained primary",
          click: async (modal) => {
            const c = $ctrl.cart.checkout.customer;
            c.streetName = suggestedAddress.streetName;
            c.streetNumber = suggestedAddress.streetNumber;
            c.floorNumber = suggestedAddress.floorNumber || null;
            c.side = suggestedAddress.side || null;
            c.roomNumber = suggestedAddress.roomNumber || null;
            c.postalCode = suggestedAddress.postalCode;
            c.city = suggestedAddress.city;
            modal.closeModal();
            await internalCheckout();
          },
        },
      ]);
    }

    function scrollToAddressField() {
      $timeout(function () {
        var el =
          document.getElementById("dawa-address") ||
          document.querySelector('input[name="streetName"]');
        if (el && typeof el.scrollIntoView === "function") {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus();
        }
      }, 100);
    }
  },

  templateUrl: "/shop-dist/templates/checkout-dawa.html?c=" + window.cacheBurst,
  bindings: {
    siteId: "@",
    currentPageId: "@",
  },
});
